import hex from 'crypto-js/enc-hex';
import sha256 from 'crypto-js/sha256';
import { PortalPersistentBlock } from '@nx-frontend/shared/types';
import { ClipboardBlock } from './types';

export const getBlockChecksum = (blocks: PortalPersistentBlock[]): string => {
  return sha256(JSON.stringify(blocks)).toString(hex);
};

export const validateBlockData = (data: object): boolean => {
  if (data === null || typeof data !== 'object') {
    console.warn('Invalid data: data is not an object.');
    return false;
  }

  const requiredProperties: (keyof ClipboardBlock)[] = [
    'type',
    'sourcePortalId',
    'sourcePageId',
    'createdAt',
    'blocks',
    'checksum',
  ];

  if (!requiredProperties.every((property) => property in data)) {
    console.warn('Invalid data: Missing required properties.', { data });
    return false;
  }

  if (!('blocks' in data) || typeof data.blocks !== 'object') {
    console.warn('Invalid data: "blocks" is missing or not an object.', { data });
    return false;
  }

  if (!('checksum' in data) || getBlockChecksum(data.blocks as PortalPersistentBlock[]) !== data.checksum) {
    console.warn('Invalid data: Checksum mismatch.', { data });
    return false;
  }

  return true;
};

export const parseClipboardBlockData = (json: string): ClipboardBlock | undefined => {
  const data = JSON.parse(json) as ClipboardBlock;
  if (!validateBlockData(data)) {
    return undefined;
  }
  return data;
};
